import { render } from "./publicnoticedetail.vue?vue&type=template&id=56d82f07"
import script from "./publicnoticedetail.vue?vue&type=script&lang=js"
export * from "./publicnoticedetail.vue?vue&type=script&lang=js"

import "./publicnoticedetail.vue?vue&type=style&index=0&id=56d82f07&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__